import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import BasicInformation from './BasicInformation';
import { eventDetails, profileDto } from '../../../api/Dtos/profileDto';
import ServicesOffered from './ServicesOffered';
import LeaderShipTeam from './LeaderShipTeam';
import CenterAndLocation from './CenterAndLocation';
import BasicEventInfo from './BasicEventInfo';
import EventInfoDetails from './EventInfoDetails';
import { useLoader } from '../../../Loader/LoaderContext';
import { getService } from '../../../servce/ApisService';
import { API_ENDPOINTS } from '../../../api';

function EventPreview() {
  const userInfo = JSON.parse(localStorage.getItem("userInfo") || "{}");
    const { setLoading } = useLoader();
        const [searchParams] = useSearchParams();
                const leadId = searchParams.get("leadId");
                const vendorId =searchParams.get("vendorId");
                const names =searchParams.get('name')
    const [data,setData]=useState<profileDto | null>(null);
    const navigate = useNavigate();
    const location = useLocation();
    const path = location.pathname;
    const users = () => {
      if (path === "/portals/leads/viewUser/eventPreview") {
        navigate("/portals/leads/viewUser"); // Navigate to viewUser for Leads
    }else if(path === "/portals/proposals/viewProposal/eventPreview"){
      navigate("/portals/proposals/viewProposal");
    }else if(path === "/portals/vendors/activeVendor/eventPreview"){
      navigate("/portals/vendors/activeVendor");
    }else if( path === "/portals/vendors/inActiveVendor/eventPreview"){
      navigate("/portals/vendors/inActiveVendor");
    }else if(path === "/portals/bookings/viewBooking/eventPreview"){
      if(names == 'booked'){
        navigate("/portals/bookings/viewBooking");
      }else {
        navigate("/portals/bookings/confirmedBooking");
      }
    }else if(path ==='/portals/enquiries/contactUs/eventPreview'){
      navigate("/portals/enquiries/contactUs")
    }else if( path === "/portals/enquiries/posts/eventPreview"){
      navigate("/portals/enquiries/posts")
    }else if( path === "/portals/enquiries/events/eventPreview"){
      navigate("/portals/enquiries/events")
    }else if(path ==='/portals/enquiries/vendors/eventPreview'){
      navigate("/portals/enquiries/vendors")
    }else if(path ==='/portals/enquiries/contactUs/eventPreview'){
      navigate("/portals/enquiries/contactUs")
    }
    };
   
    const onEdit=()=>{
      if (path === "/portals/leads/viewUser/eventPreview") {
        navigate("/portals/leads/viewUser/editEvent?leadId="+leadId);  // Navigate to viewUser for Leads
      } else if(path === "/portals/proposals/viewProposal/eventPreview"){
        navigate("/portals/proposals/viewProposal/editEvent?leadId="+leadId);
      }else if(path === "/portals/vendors/activeVendor/eventPreview"){
        navigate("/portals/vendors/activeVendor/editEvent?leadId="+leadId);
      }else if( path === "/portals/vendors/inActiveVendor/eventPreview"){
        navigate("/portals/vendors/activeVendor/editEvent?leadId="+leadId);
      }else if(path === "/portals/bookings/viewBooking/eventPreview"){
        navigate("/portals/bookings/viewBooking/editEvent?leadId="+leadId+"&name="+names);
      }
  }
    useEffect(() => {
                const initializeData = async () => {
                  setLoading(true);
                  try {
                    await fetchDetails();
                    // await fetchMtCurrencyData();
                  } catch (error) {
                    console.error("Error during initialization:", error);
                  } finally {
                    setLoading(false);
                  }
                };
              
                initializeData();
              }, []);
           const fetchDetails = async () => {
                try {
                  let url:string;
                   if(path ==='/portals/enquiries/posts/eventPreview' || path ==='/portals/enquiries/vendors/eventPreview' || path ==='/portals/enquiries/contactUs/eventPreview' || vendorId ){
                                                     url = API_ENDPOINTS.getEventOrganizer+"?vendorId="+vendorId
                                                    }else{
                                                      url=API_ENDPOINTS.getEventOrganizer+"?leadId="+leadId
                                                    }
                  const response = await getService(url); // Fetch post details using 'id'
            setData(response.data);
            const res =response.data;
           
                } catch (error) {
                  console.error("Error fetching post details:", error);
                  setTimeout(() => {
                    setLoading(false); // Stop loader in case of error
                    // setIsLoading(false);
                  }, 500);
                }
              };
    return (
        <div className="h-full py-2 w-full">
            <div className="flex items-center cursor-pointer mb-4">
                <h2
                    className="mr-2 text-gray-700 font-semibold text-sm"
                    onClick={users}
                >
                     {path === "/portals/proposals/viewProposal/eventPreview" ? 'Proposal' : path === "/portals/vendors/activeVendor/eventPreview" || path === "/portals/vendors/inActiveVendor/eventPreview " ? 'Vendors' : 
                     path === "/portals/bookings/viewBooking/eventPreview" ? 'Booked' :
                     ( path === "/portals/enquiries/contactUs/eventPreview" ||  path === "/portals/enquiries/posts/eventPreview"  || path === "/portals/enquiries/events/eventPreview" || path ==='/portals/enquiries/vendors/eventPreview') ? 'Enquiries' :
                     'Leads'} 
                </h2>{" "}

                <img src="/images/arrowIcons.svg" className="mr-2" />{" "}
                <span className="text-gray-400 font-semibold text-sm">
                    
                    {path === "/portals/proposals/viewProposal/eventPreview" ? 'View Proposal': path === "/portals/vendors/activeVendor/eventPreview" || path === "/portals/vendors/inActiveVendor/eventPreview " ? 'View Vendors' :
                    path === "/portals/bookings/viewBooking/eventPreview" && names == 'booked' ? 'View Booked' : 
                    path === "/portals/bookings/viewBooking/eventPreview" && names =='confirmed' ? 'View Confirmed' :
                    path === "/portals/enquiries/contactUs/eventPreview" ? 'Contact Us' :
                    path === "/portals/enquiries/posts/eventPreview"  ? 'Posts' :
                    path === "/portals/enquiries/events/eventPreview"  ? 'Events' :
                    path ==='/portals/enquiries/vendors/eventPreview' ? 'Vendors' :
                     
                    'View Leads'}
                </span>
            </div>
            <div className='flex justify-between w-full'>
                <div className='flex items-center mb-2'>
                    <img src='/images/back.svg' className='mr-2 cursor-pointer' onClick={users} />
                    <h1 className="text-2xl font-bold text-[#2D2E2F] mr-3">{path === "/portals/proposals/viewProposal/eventPreview" ? 'View Proposal' : path === "/portals/vendors/activeVendor/eventPreview" || path === "/portals/vendors/inActiveVendor/eventPreview " ? 'View Vendors' :
                    path === "/portals/bookings/viewBooking/eventPreview" && names =='booked' ? 'View Booked' :
                    path === "/portals/bookings/viewBooking/eventPreview" && names =='confirmed' ? 'View Confirmed' :
                    ( path === "/portals/enquiries/contactUs/previewHospital" ||  path === "/portals/enquiries/posts/previewHospital"  || path === "/portals/enquiries/events/previewHospital" ) ? 'View Hospital' :
                    path === '/portals/enquiries/posts/eventPreview' ? 'View Event Organiser' :
                    path ==='/portals/enquiries/vendors/eventPreview' ? 'View Event Organiser' :
                    path ==='/portals/enquiries/contactUs/eventPreview' ? 'View Event Organiser' :
                    path ==='/portals/enquiries/events/eventPreview' ? 'View Event Organiser' :
                    'View Leads'}</h1>
                </div>
                {
                 ((userInfo?.roles !=='PUBLISHER' &&  userInfo?.roles !=='CONTENT_ADMIN' && userInfo?.roles !=='CHIEF_EDITOR') && (path !=='/portals/enquiries/contactUs/eventPreview' && path !== "/portals/enquiries/posts/previewHospital" && path !== "/portals/enquiries/events/previewHospital" && path !=='/portals/enquiries/vendors/eventPreview' )) &&
                <div className='flex items-center gradient-background p-2 text-white font-bold text-sm px-4 cursor-pointer' onClick={onEdit}><span className='mr-2'><img src='/images/Edit_Pencil.svg' /></span>Edit</div>
}
            </div>
            <div>
                <BasicEventInfo submittedData={data}/>
            </div>
            <div>
                <EventInfoDetails submittedData={data}/>
            </div>
            

        </div>
    )
}

export default EventPreview
